import "./Modals.scss";
import { Button, Modal, Tag, Typography, Divider } from "antd";
import dayjs from "dayjs";
import { ModalProps, User } from "../../utils/types";

const { Title, Text } = Typography;

type UserDetailsProps = ModalProps & {
  user: User;
};

const RowItem = ({
  label,
  value,
}: {
  label: string;
  value?: string | number | boolean | null;
}) => (
  <div className="user-info-row">
    <Text className="label">{label}</Text>
    <Text className="value">{value || "-"}</Text>
  </div>
);

const ViewUserDetailsModal = ({
  isOpen,
  setIsOpen,
  user,
}: UserDetailsProps) => {
  return (
    <Modal
      className="user-details-modal"
      open={isOpen}
      width={780}
      onCancel={() => setIsOpen(false)}
      footer={[
        <Button key="close" onClick={() => setIsOpen(false)}>
          Close
        </Button>,
      ]}
      title={
        <div className="user-header">
          <div className="avatar">
            {user.firstName?.[0]}
            {user.lastName?.[0]}
          </div>

          <div className="identity">
            <Title level={4} style={{ margin: 0 }}>
              {user.firstName} {user.lastName}
            </Title>
            <Text type="secondary">
              {user.jobTitle || "Employee"} • {user.companyName || ""}
            </Text>
          </div>

          <div className="status">
            <Tag color={user.status === "ACTIVE" ? "green" : "red"}
              
            >
              {user.status}
            </Tag>
          </div>
        </div>
      }
    >
      {/* CONTACT */}
      <Divider />
      <Title level={5} className="section-title">
        Contact
      </Title>
      <div className="section-grid">
        <RowItem label="Employee Code" value={user.employeeCode} />
        <RowItem label="Email" value={user.email} />
        <RowItem label="Manager" value={user.managerFullName} />
        <RowItem label="Timekeeper" value={user.timekeeperFullName} />
      </div>

      {/* ORGANIZATION */}
      <Divider />
      <Title level={5} className="section-title">
        Organization
      </Title>
      <div className="section-grid">
        <RowItem label="Company" value={user.companyName} />
        <RowItem label="Department" value={user.departmentName} />
      </div>

      {/* EMPLOYMENT */}
      <Divider />
      <Title level={5} className="section-title">
        Employment
      </Title>
      <div className="section-grid">
        <RowItem label="Employee Type" value={user.employeeType} />
        <RowItem label="Work Hours" value={user.workHours} />
        <RowItem
          label="Base Contract"
          value={user.baseContract ? "Yes" : "No"}
        />
        <RowItem label="Status" value={user.status} />
        <RowItem
          label="Employment start"
          value={
            user.employmentStartDate
              ? dayjs(user.employmentStartDate).format("DD.MM.YYYY")
              : null
          }
        />
        <RowItem
          label="Employment end"
          value={
            user.employmentEndDate
              ? dayjs(user.employmentEndDate).format("DD.MM.YYYY")
              : null
          }
        />
        <RowItem label="Entitlement" value={user.entitlement} />
        <RowItem label="Current Year Days" value={user.currentYearDays} />
        <RowItem label="Previous Year Days" value={user.previousYearDays} />
      </div>

      {/* ROLES */}
      <Divider />
      <Title level={5} className="section-title">
        System Roles
      </Title>
      <div className="roles">
        {user.roles?.length
          ? user.roles.map((r) => (
              <Tag key={r} className="role-tag">
                {r}
              </Tag>
            ))
          : "-"}
      </div>
    </Modal>
  );
};

export default ViewUserDetailsModal;
